module.exports = __webpack_public_path__ + "images/bookmark-blue-f4565a1b.svg";